import styled from "styled-components";
import { breakpoints, maxWidth } from "../../../styles/variables/breakpoints";
import { colors } from "../../../styles/variables/colors";

export const QueryInput = styled.input`
  min-width: 500px;
  padding: 1rem 1.5rem;
  font-size: 21px;
  border: none;
  outline: none;
  ${maxWidth(breakpoints.lg)} {
    min-width: 240px;
    font-size: 14px;
  }
  ${maxWidth(breakpoints.sm)} {
    min-width: 140px;
    max-width: 140px;
    font-size: 14px;
  }
`;

export const Submit = styled.input`
  padding: 1.25rem 5rem 1.15rem 2rem;
  border: 0;
  border-radius: 0;
  box-shadow: none;
  background-color: ${colors.blue};
  color: white;
  background-repeat: no-repeat;
  background-size: 2.2rem;
  background-image: url(/modules/custom/custom_react_maps/img/search-icon-white.svg);
  background-position: 50% 48%;
  transition: all 0.4s;
  outline: none;
  &:hover {
    background-color: ${colors.lightBlue};
  }
  ${maxWidth(breakpoints.lg)} {
    padding: 0.9rem 5rem 0.8rem 2rem;
  }
  ${maxWidth(breakpoints.sm)} {
    padding: 1.1rem 2rem 0.9rem 2rem;
    background-size: 1.8rem;
  }
`;

export const Form = styled.form`
  display: flex;
  align-items: center;
`;
